import { render } from "./cookie_consent.vue?vue&type=template&id=11589586"
import script from "./cookie_consent.vue?vue&type=script&lang=js"
export * from "./cookie_consent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__